import script from "./icon-two-tones-first-line.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-first-line.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-first-line.vue?vue&type=style&index=0&id=69459dad&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69459dad"]])

export default __exports__